import * as moment from 'moment-timezone';

export const EASTERN_TIME_ZONE = 'America/New_York';
export const BENEV_DELIVERY_CUTOFF_HOUR_ET = 14;
export const BENEV_DELIVERY_SCHEDULE = [
  { day: 'Sunday', before: 4, after: 4 }, // Thursday, Thursday
  { day: 'Monday', before: 4, after: 5 }, // Thursday, Friday
  { day: 'Tuesday', before: 5, after: 2 }, // Friday, Tuesday
  { day: 'Wednesday', before: 2, after: 2 }, // Tuesday, Tuesday
  { day: 'Thursday', before: 2, after: 3 }, // Tuesday, Wednesday
  { day: 'Friday', before: 3, after: 4 }, // Wednesday, Thursday
  { day: 'Saturday', before: 4, after: 4 }, // Thursday, Thursday
];

export function getEarliestSelectableDeliveryDate(referenceDate: Date = new Date()) {
  const easternNow = moment(referenceDate).tz(EASTERN_TIME_ZONE);
  const currentWeekday = easternNow.day();
  const useAfterCutoffTable =
    easternNow.hour() >= BENEV_DELIVERY_CUTOFF_HOUR_ET;

  const schedule = BENEV_DELIVERY_SCHEDULE[currentWeekday];
  const targetWeekday = useAfterCutoffTable
    ? schedule.after
    : schedule.before;

  let daysToAdd = (targetWeekday - currentWeekday + 7) % 7;
  if (daysToAdd === 0) {
    daysToAdd = 7;
  }

  const targetDate = easternNow
    .clone()
    .startOf('day')
    .add(daysToAdd, 'days');

  return new Date(targetDate.year(), targetDate.month(), targetDate.date());
}

export function formatDateAsYmd(dateValue: Date) {
  const date = new Date(dateValue);
  const year = date.getFullYear();
  const month = `${date.getMonth() + 1}`.padStart(2, '0');
  const day = `${date.getDate()}`.padStart(2, '0');
  return `${year}-${month}-${day}`;
}

export function parseRequestedDeliveryDate(value: any): Date | null {
  if (!value) {
    return null;
  }

  if (value instanceof Date) {
    if (isNaN(value.getTime())) {
      return null;
    }
    return new Date(value.getFullYear(), value.getMonth(), value.getDate());
  }

  if (typeof value === 'string') {
    const ymdMatch = value.match(/^(\d{4})-(\d{2})-(\d{2})$/);
    if (ymdMatch) {
      const year = Number(ymdMatch[1]);
      const month = Number(ymdMatch[2]);
      const day = Number(ymdMatch[3]);
      return new Date(year, month - 1, day);
    }
  }

  const parsed = new Date(value);
  if (isNaN(parsed.getTime())) {
    return null;
  }

  return new Date(parsed.getFullYear(), parsed.getMonth(), parsed.getDate());
}

export function hasRequestedDeliveryCutoffPassed(
  requestedDeliveryDate: any,
  referenceDate: Date = new Date(),
) {
  const parsedDate = parseRequestedDeliveryDate(requestedDeliveryDate);
  if (!parsedDate) {
    return false;
  }

  const earliestGuaranteedDate = getEarliestSelectableDeliveryDate(referenceDate);
  return parsedDate.getTime() < earliestGuaranteedDate.getTime();
}
